var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.canaryMarker)?_c('label',{staticClass:"marker"},[_c('span',{staticClass:"close"},[_vm._v("×")]),_c('input',{attrs:{"type":"checkbox"}}),_c('span',{staticClass:"canary"},[_vm._v(_vm._s(_setup.canaryMarker))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }